module.exports = __webpack_public_path__ + "static/media/2-1-canada-preframed-poster.c8d0d76c.png";